import { useQuery } from 'react-query';
import { getUserPermissionsByEmailAPI, hasPermissionsByEmail } from './api';

export const USER_PERMISSIONS_BY_EMAIL = 'userPermissionsByEmail';

export function useUserPermissionsByEmail(email) {

  const { data: permissions, isLoading, isFetching } = useQuery(
    [USER_PERMISSIONS_BY_EMAIL, email],
    () => getUserPermissionsByEmailAPI(email),
    {
      enabled: !!email,
    },
  );

  const checkPermissionsByEmail = (resource, action) => hasPermissionsByEmail(permissions, resource, action);

  return {
    checkPermissionsByEmail,
    permissionsByEmail: permissions || null,
    isLoading,
    isFetching,
  };
}
